var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isList)?_c('location-list',{ref:"table",attrs:{"title":"Locations Management","loading":_vm.loading}}):_c('location-view',{ref:"locationView",attrs:{"id":_vm.id,"loading":_vm.loading},on:{"save-location":_vm.saveLocation,"delete-section":_vm.deleteSection,"save-section":_vm.saveSection,"delete-location":_vm.deleteLocation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }